// src/features/presence/format.ts
// IR-1148 presence dashboard — small shared formatting helpers.

/** Format a duration in seconds as a compact "Xh Ym Zs" / "Xm Ys" / "Xs" string. */
export function formatDuration(sec: number | null | undefined): string {
  const total = Math.max(0, Math.round(Number(sec) || 0));
  if (total === 0) return "0s";
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  const parts: string[] = [];
  if (h > 0) parts.push(`${h}h`);
  if (m > 0) parts.push(`${m}m`);
  if (s > 0 && h === 0) parts.push(`${s}s`);
  return parts.join(" ") || "0s";
}

/** Format a ratio (0..1) as a whole-number percentage string. */
export function formatRatioPct(ratio: number | null | undefined): string {
  const r = Number(ratio) || 0;
  return `${Math.round(r * 100)}%`;
}
